module.exports = __webpack_public_path__ + "img/welcome.00d3a705.png";